import React from 'react'
import { BrowserRouter as Router, Switch, Route } from 'react-router-dom'
import Home from './components/pages/home'
import Estimates from './components/pages/estimate-compare'
import IndividualEstimate from './components/pages/estimate-details'
import ProceedEstimate from './components/pages/proceed-estimate'
import RequestCancellationPage from './components/pages/requestCancellationPage'
import QuoteDetails from './components/pages/email/estimate-details'
import ReviewProposal from './components/pages/proposal'
import ProposalAccepted from './components/pages/proposal/accepted'
import Login from './components/pages/login'
import { Provider } from 'react-redux'
import CheckUserAccess from './components/checkUserAccess'
import ConsultantContainer from './containers/consultantContainer'
import ConsultantUserActivity from './containers/consultantUserActivity'
import Settlements from './components/pages/settlements'
import Logout from './components/pages/logout'
import { PersistGate } from 'redux-persist/integration/react'
import { store, persistor } from './store/configureStore'
import NotFoundPage from './components/pages/notFoundPage.js'
import HttpsRedirect from 'react-https-redirect'
import PdfView from 'components/pages/pdf/pdfView'
import './styles/style.scss'
import { ThemeProvider } from '@emotion/react'
import { GlobalStyles } from 'components/styledComponents/globalStyles'
import { theme } from './utils/theme'

function App() {
  // This is to clear all user data once the browser is closed
  // This event is also getting triggered on page refresh. Need to handle it in a way so that it is only triggered on closing the browser
  /*window.onbeforeunload = function (e) {
    localStorage.clear()
  }*/

  return (
    <HttpsRedirect>
      <Provider store={store}>
        <Router>
          <PersistGate persistor={persistor}>
            <CheckUserAccess />
            <ThemeProvider theme={theme}>
              <GlobalStyles theme={theme} />
              <Switch>
                <Route
                  path={[
                    '/estimates/:estimateId',
                    '/consultant/estimates/:estimateId',
                  ]}
                  exact
                  component={IndividualEstimate}
                />
                <Route
                  path={['/home', '/consultant/home']}
                  exact
                  component={Home}
                />
                <Route
                  path={[
                    '/estimates/:estimateId/pdfview',
                    '/consultant/estimates/:estimateId/pdfview',
                  ]}
                  exact
                  component={() => <PdfView type="estimate" />}
                />
                <Route
                  path={['/consultant/estimates', '/estimates']}
                  exact
                  component={Estimates}
                />
                <Route
                  path="/consultant/login"
                  exact
                  component={ConsultantContainer}
                />
                <Route
                  path="/consultant/useractivity"
                  exact
                  component={ConsultantUserActivity}
                />
                <Route path="/settlements" exact component={Settlements} />
                <Route
                  path="/consultant/settlements"
                  exact
                  component={Settlements}
                />
                <Route
                  path={[
                    '/proposal/:estimateId/review',
                    '/consultant/proposal/:estimateId/review',
                  ]}
                  exact
                  component={ReviewProposal}
                />
                <Route
                  path={[
                    '/consultant/proposal/:estimateId/review/pdfview',
                    '/proposal/:estimateId/review/pdfview',
                  ]}
                  exact
                  component={() => <PdfView type="proposal" />}
                />
                <Route path="/logout/:opportunityId" exact component={Logout} />
                <Route path="/login" exact component={Login} />

                <Route
                  path="/estimates/:estimateId/proceed"
                  exact
                  component={ProceedEstimate}
                />
                <Route
                  path="/estimates/:estimateId/proceed/cancelled"
                  exact
                  component={RequestCancellationPage}
                />

                <Route
                  path="/proposal/accepted"
                  exact
                  component={ProposalAccepted}
                />
                <Route
                  path="/proposal/acceptance/cancelled"
                  exact
                  component={RequestCancellationPage}
                />
                <Route path="/quote/details" exact component={QuoteDetails} />
                <Route
                  path="/quote/details/pdfview"
                  exact
                  component={() => <PdfView type="proposal" />}
                />
                <Route path="*" component={NotFoundPage} />
              </Switch>
            </ThemeProvider>
          </PersistGate>
        </Router>
      </Provider>
    </HttpsRedirect>
  )
}

export default App
